import { createCurrentTimeState } from '@akin-home/dates/react';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
import { createReminderStore } from '../reminders/store/createReminderStore';
import { createLockScreenStore } from '../auth/lock_screen/stores';
import { createCalendarScreenState } from '../calendar/stores/calendar_screen_store/createCalendarScreenState';
import { creatChatLogStore } from '../chat/stores';
import { createChatStore } from '../chat/stores/chat';
import { createChatContextStore } from '../chat/stores/chat_context';
import { createDashboardStateStore } from '../dashboard/store/createDashboardStateStore';
import { query_client } from '../query_client';
import { createMealPlanScreenState } from '../recipes/stores/meal_plan_screen/createMealPlanScreenState';
import { createRecipeSearchScreenState } from '../recipes/stores/recipe_search_screen/createRecipeSearchScreenState';
import { createSpeechStore } from '../speech-to-text/stores';
import { createTextToSpeechState } from '../text-to-speech/createTextToSpeechState';
import { createTimerStore } from '../timer/store';
import { createUserStateStore } from '../users/stores/user_state/create_store';
import { createEventOccurenceStore } from './../calendar/stores/event_occurence_store/createEventOccurenceStore';
import { createCurrentUserStore } from './../users/stores/current_user/create_store';
import { AppState } from './app_state';

/**
 * This is our application state store.
 * It contains any information that is used globally within the application.
 *
 * We break state down into separate "modules", which are all combined here into a single store.
 */
export const useStateStore = create<AppState>()(
  persist(
    immer<AppState>(
      // This is where we combine module stores
      (...args) => ({
        /** Store the query client here */
        query_client,

        /** Our Store States */
        ...creatChatLogStore(...args),
        ...createCurrentUserStore(...args),
        ...createChatContextStore(...args),
        ...createChatStore(...args),
        ...createSpeechStore(...args),
        ...createTimerStore(...args),
        ...createCalendarScreenState(...args),
        ...createRecipeSearchScreenState(...args),
        ...createUserStateStore(...args),
        ...createMealPlanScreenState(...args),
        ...createReminderStore(...args),
        ...createLockScreenStore(...args),
        ...createDashboardStateStore(...args),
        ...createEventOccurenceStore(...args),
        ...createCurrentTimeState(...args),
        ...createTextToSpeechState(...args),
      })
    ),
    {
      name: 'app-state',
      getStorage: () => AsyncStorage,

      /** This is where we select portions of state to store in persistent storage */
      partialize: (state) => ({
        // We want to remember if the user wants the wake word enabled on this device
        wake_word_enabled: state.wake_word_enabled,
        // Remember the last active user account. We can use this to select that user when the app is reloaded
        current_user_id: state.current_user_id,

        /** Remember tts settings */
        tts_enabled: state.tts_enabled,
      }),
    }
  )
);
